<template>
  <el-dialog class="dialog-simple" :visible.sync="visible" :title="dialogTitle" width="580px" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" :size="size" ref="dataForm" label-position='right' label-width="120px" v-loading="dialogLoading">
      <el-form-item prop="workBaseId" label="基地站">
        <el-select v-model="dataForm.workBaseId" style="width: 100%;" placeholder="" clearable>
          <el-option v-for="item in baseList" :key="item.id" :value="item.id" :label="item.name"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="remark" label="备注">
        <el-input v-model.trim="dataForm.remark" placeholder="" clearable></el-input>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" slot="footer" style="text-align: right">
      <el-button class="submit" :size="size" type="primary" @click="submitHandle()" :loading="dialogLoading">确 定</el-button>
      <el-button class="close" :size="size" @click="visible = false">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  name: 'addOrUpdate',
  props: {
    dialogTitle: {
      type: String,
      default: '选派站点'
    },
    isRedispatch: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      size: 'small',
      dialogLoading: false,
      visible: false,
      baseList: [],
      dataForm: {
        orderId: 0,
        workBaseId: '',
        remark: ''
      },
    }
  },
  computed: {
    dataRule () {
      return {
        workBaseId: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init (row, title) {
      this.title = title
      this.visible = true
      let clientsCompanyId = [row.clientsCompanyId]
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        this.dataForm.orderId = row.workOrderId
        Promise.all([
          this.$api.electricOperations.listElectricOperationsWorkBases(0).then((res) => {
            if (res.success) {
              this.baseList = res.data
            }
          }),
          this.$api.electricOperations.listElectricOperationsWorkOrderDispatchingPriorityRegulation(0, clientsCompanyId).then((res) => {
            if (res.success) {
              this.dataForm.workBaseId = res.data[0].workBaseId
            }
          })
        ])
      })
    },
    handleGetInfo () {
    },
    submitHandle:debounce (function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.dialogLoading = true
        this.$api.electricOperations.setElectricOperationsWorkOrderToWorkBase(
          this.dataForm.orderId,
          this.dataForm.workBaseId,
          this.dataForm.remark
        ).then((res) => {
          if (res.success) {
            this.visible = false
            this.$message.success('操作成功')
            this.$emit('handleQuery')
          }
          this.dialogLoading = false
        }).catch(() => this.dialogLoading = false)
      })
    }, 1000, { 'leading': true, 'trailing': false } )
  }
}
</script>

<style lang="scss" scoped>
</style>
